<template>
  <div class="documentUploader">
    <v-file-input
      v-on:change="fileSelected"
      v-model="files"
      label="Document Upload"
    ></v-file-input>

    <v-btn v-on:click="submitFiles" class="default-action-btn">Upload</v-btn>
  </div>
</template>

<script>
import { DocumentsAPI } from "@/lib/api"
import EventBus from "@/lib/eventBus"

export default {
  name: "DocumentUpload",
  data() {
    return {
      file: {},
      files: []
    }
  },
  props: {
    resourceParentId: { type: Number, default: 0 }
  },
  methods: {
    fileSelected(File) {
      this.file = File
    },
    submitFiles() {
      if (this.resourceParentId > 0) {
        this.file.learning_item_id = this.resourceParentId
      }
      DocumentsAPI.create(this.file).then(() => {
        EventBus.$emit("DocumentAdded")
        this.file = {}
        this.files = []
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";
</style>
